// extracted by css-extract-rspack-plugin
export default {"programme":"programme-ZfpKi6"};